module.exports = __webpack_public_path__ + "img/skull_shrine_small.63cebc13.png";